import React from "react";

// "Chat deleted. Undo" bar at the bottom of the screen. Hidden unless there is something to undo.
export default function UndoToast({ visible, label, onUndo }) {
  return (
    <div className={`rg-toast${visible ? " is-visible" : ""}`} role="status" aria-live="polite" aria-hidden={!visible}>
      <span>{label}</span>
      <button type="button" className="rg-toast-btn" onClick={onUndo} tabIndex={visible ? 0 : -1}>
        Undo
      </button>
    </div>
  );
}
